import { createContext, useContext, useState, useCallback, useEffect } from "react";

export const TRANSLATIONS = {
  fr: {
    nav: { prestations: "Prestations", coveringServices: "Covering & Services", ppf: "Protection PPF", dechromage: "Déchromage & Bandes", vitres: "Vitres Teintées", polissage: "Polissage", services: "Services", realisations: "Réalisations", teintes: "Teintes", films: "Films Phares", pourquoi: "Pourquoi nous", tarifs: "Tarifs", reserver: "Réserver", devis: "Devis", advisor: "Style AI", connexion: "Connexion", compte: "Mon compte", devisBtn: "Devis Gratuit" },
    hero: {
      tag: "/ Atelier de Covering & Protection Automobile",
      subtitle: "Votre voiture, réinventée. Covering sur-mesure, protection PPF et finitions d'exception pour véhicules de sport et de luxe.",
      cta: "Demander un Devis Gratuit",
    },
    preLaunch: {
      badge: "Bientôt disponible",
      heroBanner: "Wrapp Man prépare son lancement à Saint-Martin. Nous démarrons sous une structure professionnelle sous tente, avec un environnement de pose maîtrisé — covering, chrome delete et detailing dès l'ouverture.",
      pricingNote: "Les tarifs ci-dessous sont notre grille officielle « à partir de ». La prise de rendez-vous en ligne ouvrira très bientôt.",
      bookingsDisabled: "Les réservations ouvriront très bientôt. Restez connectés !",
      bookingsHint: "En attendant, vous pouvez nous laisser une demande d'information via le formulaire ci-dessous.",
      galleryTitle: "Notre portfolio arrive bientôt",
      galleryBody: "Notre portfolio arrive bientôt. Les vraies réalisations Wrapp Man seront ajoutées après notre ouverture officielle.",
      aiDisclaimer: "Les images présentées sur ce site sont des illustrations conceptuelles générées par IA à des fins de démonstration uniquement et ne représentent pas de projets clients réalisés.",
      quoteHint: "Vous pouvez déjà nous envoyer votre projet — nous vous recontacterons dès l'ouverture officielle.",
      footerNotice: "Wrapp Man prépare son lancement — Structure professionnelle sous tente, Saint-Martin.",
    },
    ribbon: ["Covering Total", "PPF", "Chrome Delete", "Lavage Premium", "Finition Premium", "Films Garantis"],
    services: {
      tag: "/ Nos Services",
      title1: "Ce que l'on",
      title2: "fabrique",
      subtitle: "Du covering intégral à la protection invisible, chaque prestation est pensée pour sublimer et protéger.",
      items: {
        covering: { title: "Covering Total & Partiel", desc: "Transformez intégralement la teinte de votre véhicule avec des films premium mats, brillants ou satinés. Une finition d'atelier, sans compromis." },
        ppf: { title: "Film de Protection PPF", desc: "Paint Protection Film auto-cicatrisant. Une armure invisible contre les gravillons, rayures et agressions du quotidien." },
        dechromage: { title: "Déchromage — Chrome Delete", desc: "Noircissez chromes et enjoliveurs pour un look racé et furtif. Le détail qui change tout." },
        flotte: { title: "Covering Flotte / Publicitaire", desc: "Habillez votre flotte aux couleurs de votre marque. Un support roulant qui travaille pour vous." },
      },
    },
    gallery: {
      tag: "/ Nos Réalisations",
      title: "Avant",
      titleAfter: "Après",
      subtitle: "Glissez le curseur pour révéler la transformation.",
      before: "Avant",
      after: "Après",
      items: { 1: "Audi RS — Bleu Nardo Satiné", 2: "GT Coupé — Chrome Delete Total", 3: "Supercar — Covering Nuit Néon" },
    },
    colors: {
      tag: "/ Nos Teintes de Covering",
      title1: "Nos",
      title2: "Teintes",
      subtitle: "Un nuancier premium de vinyles brillants, métallisés et PET haut de gamme. Chaque teinte posée à la perfection.",
      cta: "Je veux cette teinte",
      items: {
        bleu: { name: "Bleu Électrique Métallisé", tag: "Métallisé", desc: "Intensité et reflets métalliques saisissants." },
        rouge: { name: "Rouge Bordeaux Métallisé", tag: "Métallisé", desc: "Profondeur et caractère, effet bijou." },
        noir: { name: "Noir Diamant — PET", tag: "PET Premium", desc: "Brillance miroir, film PET haut de gamme." },
        gris: { name: "Gris Nardo Métallisé", tag: "Métallisé", desc: "Sportif et discret, ultra tendance." },
        blanc: { name: "Blanc Perle Brillant", tag: "Brillant", desc: "Élégance intemporelle, éclat profond." },
      },
    },
    polish: {
      tag: "/ Polissage & Rénovation",
      title1: "Polissage",
      title2: "Carrosserie",
      subtitle: "On redonne à votre peinture son éclat d'origine. Un traitement de précision qui efface les défauts et révèle la profondeur de la teinte.",
      bullets: [
        "Élimination des rayures et micro-rayures",
        "Suppression des éclats et défauts de surface",
        "Correction des tourbillons (swirl marks) et hologrammes",
        "Restauration de la brillance et protection longue durée",
      ],
      cta: "Réserver un polissage",
    },
    ppf: {
      tag: "/ Protection PPF",
      title1: "Film de Protection",
      title2: "PPF",
      subtitle: "Une armure invisible en TPU auto-cicatrisant. Protégez votre carrosserie tout en sublimant sa finition.",
      features: ["Auto-cicatrisant", "Anti-jaunissement", "Anti-gravillons", "Haute brillance"],
      cta: "Protéger ma voiture",
      items: {
        transparent: { name: "PPF Transparent (TPU)", tag: "Invisible", desc: "Finition ultra-claire qui préserve la teinte d'origine. Les micro-rayures se réparent à la chaleur." },
        noir: { name: "PPF Noir Brillant — Piano Black", tag: "Effet Miroir", desc: "Un noir profond effet miroir, avec la protection self-healing contre rayures et UV." },
      },
    },
    dechromage: {
      tag: "/ Déchromage & Bandes",
      title1: "Déchromage",
      title2: "& Bandes",
      subtitle: "Le détail qui change tout. Contours noircis et bandes racing sur-mesure.",
      items: {
        vitres: { name: "Déchromage Contours de Vitres", tag: "Avant / Après", desc: "On noircit tous les chromes pour un look full black homogène et racé.", cta: "Réserver mon déchromage" },
        bandes: { name: "Bandes & Stripping Racing", tag: "Personnalisé", desc: "Bandes capot et bas de caisse sur-mesure. Plusieurs styles pour affirmer votre look.", cta: "Personnaliser mes bandes" },
      },
    },
    tint: {
      tag: "/ Vitres Teintées",
      title1: "Vitres",
      title2: "Teintées",
      subtitle: "Confort, intimité et protection UV. Choisissez votre niveau de teinte (VLT), du plus clair au plus foncé.",
      vltLabel: "Niveau de transparence (VLT)",
      cta: "Demander un devis teintage",
      note: "Plus le pourcentage est bas, plus la teinte est foncée. Nous vous conseillons selon la réglementation en vigueur.",
    },
    headlights: {
      tag: "/ Nos Films pour Phares",
      title1: "Films",
      title2: "Phares",
      subtitle: "Personnalisez et protégez vos optiques. Films premium teintés ou transparents, posés avec précision.",
      cta: "Demander ce film",
      items: {
        jaune: { name: "Film Jaune Doré", tag: "Style", desc: "Look sport et lumière chaude. L'esprit rétro-racing pour un regard unique." },
        bleu: { name: "Film Bleu", tag: "Style", desc: "Teinte bleutée effet xénon. Un regard moderne, racé et lumineux." },
        transparent: { name: "Film de Protection Transparent", tag: "Protection", desc: "Protège vos optiques des gravillons et rayures, sans altérer la couleur d'origine." },
        noir: { name: "Film Noir Fumé", tag: "Tuning", desc: "Assombrit feux avant et arrière pour un look furtif et agressif." },
      },
    },
    why: {
      tag: "/ Pourquoi nous choisir",
      title: "Le manifeste",
      titleBrand: "Wrapp Man",
      items: {
        "01": { title: "Finition Haut de Gamme", desc: "Chaque pose est réalisée dans un environnement de pose maîtrisé, avec un soin obsessionnel du détail. Bords invisibles, angles parfaits." },
        "02": { title: "Films Garantis", desc: "Nous travaillons exclusivement des films premium certifiés, garantis plusieurs années contre le jaunissement et le décollement." },
        "03": { title: "Protection de la Peinture", desc: "Sous le film, votre peinture d'origine reste intacte. Réversible, revalorisant, et une protection réelle au quotidien." },
      },
    },
    advisor: {
      tag: "/ Style AI",
      title1: "Trouvez votre",
      title2: "signature",
      subtitle: "Décrivez votre voiture et l'ambiance que vous cherchez. Notre IA vous recommande une teinte, une finition et une marque de vinyle en quelques secondes.",
      vehicle: "Véhicule",
      vehiclePh: "ex : Porsche 911, Range Rover Sport, BMW M3…",
      description: "Style souhaité",
      descriptionPh: "ex : Un look furtif, plutôt sombre, sportif mais élégant. J'aime les finitions satinées et l'aspect métallisé…",
      submit: "Obtenir ma reco",
      thinking: "Analyse en cours…",
      retry: "Réessayer",
      emptyState: "Notre IA analyse votre véhicule et votre style pour vous suggérer la combinaison idéale.",
      resultTag: "Notre recommandation",
      finishLabel: "Finition",
      brandLabel: "Vinyle",
      complementaryLabel: "Suggestion complémentaire",
      ctaQuote: "Envoyer ma demande",
      poweredBy: "Propulsé par Wrapp Assistant · GPT-5.6 Luna",
      photo: "Photo du véhicule",
      photoOptional: "(optionnel)",
      photoCta: "Ajouter une photo (JPG, PNG, WEBP · 10 Mo max)",
      photoHint: "Ajoutez une photo pour visualiser le rendu de la teinte sur votre voiture",
      renderTag: "Aperçu IA",
      renderCta: "Générer le rendu",
      rendering: "Génération en cours…",
      renderPoweredBy: "Propulsé par Nano Banana · Gemini 3.1",
      renderBadge: "Rendu IA",
      renderAlt: "Rendu IA du véhicule avec la teinte recommandée",
      renderNoPhoto: "Ajoutez une photo de votre voiture pour visualiser le rendu de la teinte recommandée.",
      original: "Original",
      errRequired: "Merci d'indiquer votre véhicule et votre style souhaité.",
      errGeneric: "Notre IA est momentanément indisponible. Réessayez dans un instant.",
      errFileSize: "L'image dépasse 10 Mo. Merci de compresser ou choisir un fichier plus petit.",
      errRender: "Le rendu IA a échoué. Réessayez avec une autre photo.",
    },
    pricing: {
      tag: "/ Grille Tarifaire Professionnelle",
      title1: "Nos",
      title2: "Tarifs",
      subtitle: "Une grille transparente, à partir de. Chaque devis est finalisé après inspection du véhicule.",
      quoteCta: "Demander un devis",
      priceFrom: "à partir de",
      materialsTitle: "Matériaux premium",
      materials: "Avery Dennison · 3M · HEXIS",
      colHeaderLabel: "Prestation",
      colHeaderDesc: "Description",
      colHeaderPrice: "Tarif à partir de",
      phase1: {
        label: "Phase 1 — Lancement",
        intro: "Nous démarrons à Saint-Martin sous une structure professionnelle sous tente — un environnement de pose maîtrisé, dédié au covering, chrome delete, moto et detailing dès l'ouverture.",
        groups: [
          {
            title: "Covering Automobile & Moto",
            desc: "Personnalisez et protégez votre véhicule avec un style unique.",
            items: [
              { label: "Capot seul", note: "Finition mat, satin, brillant ou carbone 3D/4D", price: "300 €" },
              { label: "Toit seul", note: "Toit panoramique ou classique", price: "350 €" },
              { label: "Rétroviseurs (la paire)", note: "Finition au choix", price: "180 €" },
              { label: "Chrome Delete (calandre / vitres)", note: "Recouvrement complet des baguettes chromées", price: "350 €" },
              { label: "Bandeau pare-brise / Stripping", note: "Bande pare-soleil ou bandes sportives", price: "150 €" },
              { label: "Moto — éléments seuls", note: "Réservoir, carénages, casques (à la demande)", price: "250 €" },
              { label: "Moto complète", note: "Roadster, sportive (tous carénages)", price: "1 200 €" },
              { label: "Covering complet — Citadine", note: "Ex. Fiat 500, Toyota Yaris, Renault Clio", price: "2 000 €" },
              { label: "Covering complet — Berline / SUV", note: "Ex. Hyundai Elantra, RAV4, Sedan, SUV compact", price: "2 800 €" },
              { label: "Covering complet — Grand SUV / Pick-up", note: "Ex. Ford F-150, Jeep Wrangler, véhicules de luxe", price: "4 500 €" },
            ],
          },
          {
            title: "Lavage & Polissage (Detailing)",
            desc: "Préparez et sublimez votre véhicule avec un rendu impeccable.",
            items: [
              { label: "Lavage décontamination pré-wrap", note: "Strip wash + dégraissage + IPA 99%", price: "150 €" },
              { label: "Polissage 1 passe (brillance)", note: "Correction légère + brillance", price: "400 €" },
              { label: "Polissage 2-3 passes (correction)", note: "Correction avancée + finition miroir", price: "800 €" },
            ],
          },
        ],
      },
      phase2: {
        label: "Phase 2 — Développement",
        badge: "À venir",
        intro: "Une fois l'atelier permanent installé, Wrapp Man ouvrira sa deuxième phase — prestations exigeant un environnement encore plus rigoureux : Protection PPF et Vitres Teintées.",
        groups: [
          {
            title: "Protection PPF (Paint Protection Film)",
            desc: "Protection invisible et durable contre rayures, impacts et UV.",
            items: [
              { label: "PPF Face avant (bloc avant)", note: "Pare-chocs, capot, ailes, rétroviseurs, phares", price: "1 500 €" },
              { label: "PPF Zones spécifiques", note: "Seuils, poignées, bas de caisse, etc.", price: "300 €" },
              { label: "PPF Protection complète", note: "Véhicule entier", price: "5 500 €" },
            ],
          },
          {
            title: "Vitres Teintées",
            desc: "Confort, confidentialité et protection contre la chaleur.",
            items: [
              { label: "Teintage complet (voiture)", note: "Toutes les vitres (sauf pare-brise)", price: "400 €" },
              { label: "Teintage optiques / phares (la paire)", note: "Protection et style", price: "180 €" },
              { label: "Teintage pare-brise", note: "Selon réglementation", price: "250 €" },
            ],
          },
        ],
      },
      disclaimer: "Tous les tarifs sont donnés à titre indicatif « à partir de » et peuvent varier selon l'état du véhicule, la complexité des formes, le type de vinyle sélectionné (Avery Dennison, 3M, HEXIS) et les options choisies. Un devis personnalisé est réalisé après inspection.",
    },
    payment: {
      tag: "/ Réserver & Payer",
      title1: "Réservez",
      title2: "en ligne",
      subtitle: "Forfaits à prix fixe payables par carte : réglez l'intégralité ou un acompte de 50 % pour bloquer votre créneau. Paiement sécurisé par Stripe.",
      full: "Intégral",
      deposit: "Acompte 50%",
      pay: "Payer",
      securedBy: "Paiement 100% sécurisé — Visa · Mastercard · CB",
      custom: {
        title: "Covering complet, semi-covering ou PPF ?",
        desc: "Ces projets sont sur-mesure (taille du véhicule, type de vinyle). Demandez votre devis : nous vous envoyons ensuite un lien de paiement pour l'acompte (30 à 50 %).",
        cta: "Demander un devis sur-mesure",
      },
      packages: {
        reservation: { name: "Acompte de réservation", note: "Bloque votre créneau — déduit de la facture finale." },
        lavage: { name: "Lavage Intérieur / Extérieur", note: "Préparation & nettoyage complet." },
        toit: { name: "Covering de toit", note: "Toit noir brillant ou mat." },
        feux: { name: "Teintage de feux", note: "Feux avant / arrière teintés." },
        dechromage_citadine: { name: "Déchromage Citadine / Compacte", note: "Chrome delete complet." },
        dechromage_berline: { name: "Déchromage Berline / SUV", note: "Chrome delete complet." },
      },
    },
    quote: {
      tag: "/ Devis Gratuit",
      title1: "Parlons de",
      title2: "votre projet",
      subtitle: "Décrivez votre véhicule et la prestation souhaitée. On revient vers vous sous 24h avec une estimation personnalisée.",
      name: "Nom *", namePh: "Votre nom",
      phone: "Téléphone *", phonePh: "06 xx xx xx xx",
      email: "Email *", emailPh: "vous@email.com",
      vehicle: "Marque / Modèle du véhicule *", vehiclePh: "ex : Audi RS6, Porsche 911...",
      service: "Prestation souhaitée *", servicePh: "Choisir une prestation",
      message: "Message (optionnel)", messagePh: "Détails, couleur envisagée, délais...",
      submit: "Envoyer ma demande", sending: "Envoi...",
      successTitle: "Merci !", successMsg: "Votre demande a bien été reçue. Notre équipe vous recontacte rapidement.",
      newRequest: "Nouvelle demande",
      errRequired: "Merci de remplir tous les champs obligatoires.",
      errGeneric: "Une erreur est survenue. Réessayez.",
      okToast: "Demande envoyée ! Nous vous recontactons très vite.",
      serviceOptions: ["Covering Partiel", "Covering Total", "Lavage Intérieur / Extérieur", "Film de Protection PPF", "Autre"],
    },
    footer: {
      blurb: "Atelier de covering automobile & protection de carrosserie. Précision, films premium et véhicules d'exception.",
      contact: "Coordonnées", hours: "Horaires",
      week: "Lun – Ven : 9h – 19h", sat: "Samedi : 10h – 17h", sun: "Dimanche : Fermé",
      rights: "Tous droits réservés.", tagline: "Covering · PPF · Chrome Delete",
    },
    pay: {
      checking: "Vérification du paiement...",
      successTitle: "Paiement confirmé !",
      successMsg: "Merci pour votre réservation. Un email de confirmation vous sera envoyé. Nous vous contactons pour finaliser le rendez-vous.",
      failTitle: "Paiement non confirmé",
      failMsg: "Le paiement n'a pas pu être vérifié. Aucun montant n'a été débité si l'opération a échoué.",
      cancelTitle: "Paiement annulé",
      cancelMsg: "Votre paiement a été annulé. Aucun montant n'a été débité.",
      back: "Retour à l'accueil",
    },
  },
  en: {
    nav: { prestations: "Services", coveringServices: "Wrapping & Services", ppf: "PPF Protection", dechromage: "Chrome Delete & Stripes", vitres: "Window Tinting", polissage: "Polishing", services: "Services", realisations: "Portfolio", teintes: "Colors", films: "Headlight Films", pourquoi: "Why us", tarifs: "Pricing", reserver: "Book", devis: "Quote", advisor: "Style AI", connexion: "Sign in", compte: "My account", devisBtn: "Free Quote" },
    hero: {
      tag: "/ Car Wrapping & Paint Protection Studio",
      subtitle: "Your car, reimagined. Bespoke wrapping, PPF protection and exceptional finishes for sports and luxury vehicles.",
      cta: "Request a Free Quote",
    },
    preLaunch: {
      badge: "Coming Soon",
      heroBanner: "Wrapp Man is preparing its launch in Saint Martin. We start with a professional tent-based setup — a controlled installation environment for wrapping, chrome delete and detailing from day one.",
      pricingNote: "The prices below are our official \"starting from\" grid. Online booking will open very soon.",
      bookingsDisabled: "Bookings will open soon. Stay tuned!",
      bookingsHint: "In the meantime, feel free to send us an inquiry through the form below.",
      galleryTitle: "Our portfolio is coming soon",
      galleryBody: "Our portfolio is coming soon. Real Wrapp Man projects will be added after our official launch.",
      aiDisclaimer: "Images shown on this website are AI-generated concept illustrations for demonstration purposes only and do not represent completed customer projects.",
      quoteHint: "You can already send us your project — we'll get back to you as soon as we officially open.",
      footerNotice: "Wrapp Man is preparing its launch — Professional tent-based setup, Saint Martin.",
    },
    ribbon: ["Full Wrap", "PPF", "Chrome Delete", "Premium Wash", "Premium Finish", "Warranted Films"],
    services: {
      tag: "/ Our Services",
      title1: "What we",
      title2: "craft",
      subtitle: "From full wraps to invisible protection, every service is designed to enhance and protect.",
      items: {
        covering: { title: "Full & Partial Wrap", desc: "Completely transform your vehicle's color with premium matte, gloss or satin films. Studio-grade finish, no compromise." },
        ppf: { title: "PPF Protection Film", desc: "Self-healing Paint Protection Film. An invisible armor against stone chips, scratches and daily wear." },
        dechromage: { title: "Chrome Delete", desc: "Black out chrome trims for a sharp, stealthy look. The detail that changes everything." },
        flotte: { title: "Fleet / Advertising Wrap", desc: "Dress your fleet in your brand colors. A rolling billboard that works for you." },
      },
    },
    gallery: {
      tag: "/ Our Work",
      title: "Before",
      titleAfter: "After",
      subtitle: "Drag the slider to reveal the transformation.",
      before: "Before",
      after: "After",
      items: { 1: "Audi RS — Satin Nardo Blue", 2: "GT Coupé — Full Chrome Delete", 3: "Supercar — Neon Night Wrap" },
    },
    colors: {
      tag: "/ Our Wrap Colors",
      title1: "Our",
      title2: "Colors",
      subtitle: "A premium range of gloss, metallic and high-grade PET vinyls. Every color installed to perfection.",
      cta: "I want this color",
      items: {
        bleu: { name: "Metallic Electric Blue", tag: "Metallic", desc: "Striking intensity and metallic reflections." },
        rouge: { name: "Metallic Burgundy Red", tag: "Metallic", desc: "Depth and character, jewel-like effect." },
        noir: { name: "Diamond Black — PET", tag: "Premium PET", desc: "Mirror gloss, high-grade PET film." },
        gris: { name: "Metallic Nardo Grey", tag: "Metallic", desc: "Sporty yet discreet, ultra on-trend." },
        blanc: { name: "Glossy Pearl White", tag: "Gloss", desc: "Timeless elegance, deep shine." },
      },
    },
    polish: {
      tag: "/ Polishing & Restoration",
      title1: "Paint",
      title2: "Polishing",
      subtitle: "We bring your paint back to its original shine. A precision treatment that erases defects and reveals the depth of the color.",
      bullets: [
        "Removal of scratches and micro-scratches",
        "Elimination of chips and surface defects",
        "Correction of swirl marks and holograms",
        "Restored gloss and long-lasting protection",
      ],
      cta: "Book a polishing",
    },
    ppf: {
      tag: "/ PPF Protection",
      title1: "Paint Protection",
      title2: "Film (PPF)",
      subtitle: "An invisible self-healing TPU armor. Protect your bodywork while enhancing its finish.",
      features: ["Self-healing", "Anti-yellowing", "Stone-chip proof", "High gloss"],
      cta: "Protect my car",
      items: {
        transparent: { name: "Clear PPF (TPU)", tag: "Invisible", desc: "Ultra-clear finish that preserves the original color. Micro-scratches heal with heat." },
        noir: { name: "Gloss Black PPF — Piano Black", tag: "Mirror Finish", desc: "A deep mirror-black with self-healing protection against scratches and UV." },
      },
    },
    dechromage: {
      tag: "/ Chrome Delete & Stripes",
      title1: "Chrome",
      title2: "Delete & Stripes",
      subtitle: "The detail that changes everything. Blacked-out trims and custom racing stripes.",
      items: {
        vitres: { name: "Window Trim Chrome Delete", tag: "Before / After", desc: "We black out all chrome for a clean, uniform full-black look.", cta: "Book my chrome delete" },
        bandes: { name: "Racing Stripes & Stripping", tag: "Custom", desc: "Custom hood and side stripes. Multiple styles to assert your look.", cta: "Customize my stripes" },
      },
    },
    tint: {
      tag: "/ Window Tinting",
      title1: "Window",
      title2: "Tinting",
      subtitle: "Comfort, privacy and UV protection. Choose your tint level (VLT), from lightest to darkest.",
      vltLabel: "Visible Light Transparency (VLT)",
      cta: "Request a tinting quote",
      note: "The lower the percentage, the darker the tint. We advise you according to current regulations.",
    },
    headlights: {
      tag: "/ Our Headlight Films",
      title1: "Headlight",
      title2: "Films",
      subtitle: "Customize and protect your lights. Premium tinted or clear films, precision-installed.",
      cta: "Request this film",
      items: {
        jaune: { name: "Golden Yellow Film", tag: "Style", desc: "Sporty look and warm light. Retro-racing spirit for a unique face." },
        bleu: { name: "Blue Film", tag: "Style", desc: "Bluish xenon-effect tint. A modern, sharp and bright look." },
        transparent: { name: "Clear Protection Film", tag: "Protection", desc: "Protects your lights from stone chips and scratches without altering the original color." },
        noir: { name: "Smoked Black Film", tag: "Tuning", desc: "Darkens front and rear lights for a stealthy, aggressive look." },
      },
    },
    why: {
      tag: "/ Why choose us",
      title: "The manifesto",
      titleBrand: "Wrapp Man",
      items: {
        "01": { title: "High-End Finish", desc: "Every install is done in a controlled installation environment with obsessive attention to detail. Invisible edges, perfect angles." },
        "02": { title: "Warranted Films", desc: "We only use certified premium films, warranted for years against yellowing and lifting." },
        "03": { title: "Paint Protection", desc: "Under the film, your original paint stays intact. Reversible, value-preserving, and real daily protection." },
      },
    },
    advisor: {
      tag: "/ Style AI",
      title1: "Find your",
      title2: "signature",
      subtitle: "Describe your car and the vibe you're going for. Our AI recommends a color, finish and vinyl brand in seconds.",
      vehicle: "Vehicle",
      vehiclePh: "e.g. Porsche 911, Range Rover Sport, BMW M3…",
      description: "Desired style",
      descriptionPh: "e.g. A stealthy look, rather dark, sporty yet elegant. I like satin finishes and metallic tones…",
      submit: "Get my recommendation",
      thinking: "Analyzing…",
      retry: "Try again",
      emptyState: "Our AI analyzes your vehicle and style preferences to suggest the perfect combination.",
      resultTag: "Our recommendation",
      finishLabel: "Finish",
      brandLabel: "Vinyl",
      complementaryLabel: "Complementary suggestion",
      ctaQuote: "Send my request",
      poweredBy: "Powered by Wrapp Assistant · GPT-5.6 Luna",
      photo: "Vehicle photo",
      photoOptional: "(optional)",
      photoCta: "Add a photo (JPG, PNG, WEBP · 10 MB max)",
      photoHint: "Add a photo to visualize the recommended color on your car",
      renderTag: "AI Preview",
      renderCta: "Generate render",
      rendering: "Rendering…",
      renderPoweredBy: "Powered by Nano Banana · Gemini 3.1",
      renderBadge: "AI Render",
      renderAlt: "AI render of the vehicle with the recommended color",
      renderNoPhoto: "Add a photo of your car to preview the recommended color as a render.",
      original: "Original",
      errRequired: "Please enter your vehicle and desired style.",
      errGeneric: "Our AI is temporarily unavailable. Please try again in a moment.",
      errFileSize: "The image exceeds 10 MB. Please compress it or choose a smaller file.",
      errRender: "AI render failed. Try again with another photo.",
    },
    pricing: {
      tag: "/ Professional Price Grid",
      title1: "Our",
      title2: "Pricing",
      subtitle: "A transparent \"starting from\" grid. Every quote is finalized after inspection.",
      quoteCta: "Request a quote",
      priceFrom: "from",
      materialsTitle: "Premium materials",
      materials: "Avery Dennison · 3M · HEXIS",
      colHeaderLabel: "Service",
      colHeaderDesc: "Description",
      colHeaderPrice: "Starting from",
      phase1: {
        label: "Phase 1 — Launch",
        intro: "We start in Saint Martin under a professional tent-based setup — a controlled installation environment dedicated to wrapping, chrome delete, motorcycles and detailing from day one.",
        groups: [
          {
            title: "Automotive & Motorcycle Wrapping",
            desc: "Customize and protect your vehicle with a unique style.",
            items: [
              { label: "Hood only", note: "Matte, satin, gloss or 3D/4D carbon finish", price: "€300" },
              { label: "Roof only", note: "Panoramic or classic roof", price: "€350" },
              { label: "Mirrors (pair)", note: "Finish of your choice", price: "€180" },
              { label: "Chrome Delete (grille / windows)", note: "Full coverage of chrome trims", price: "€350" },
              { label: "Windshield banner / Stripping", note: "Sun visor strip or racing stripes", price: "€150" },
              { label: "Motorcycle — parts only", note: "Tank, fairings, helmets (on request)", price: "€250" },
              { label: "Full motorcycle wrap", note: "Roadster, sport (all fairings)", price: "€1,200" },
              { label: "Full wrap — City car", note: "e.g. Fiat 500, Toyota Yaris, Renault Clio", price: "€2,000" },
              { label: "Full wrap — Sedan / SUV", note: "e.g. Hyundai Elantra, RAV4, Sedan, compact SUV", price: "€2,800" },
              { label: "Full wrap — Large SUV / Pick-up", note: "e.g. Ford F-150, Jeep Wrangler, luxury vehicles", price: "€4,500" },
            ],
          },
          {
            title: "Wash & Polish (Detailing)",
            desc: "Prep and enhance your vehicle with an impeccable finish.",
            items: [
              { label: "Pre-wrap decontamination wash", note: "Strip wash + degreasing + IPA 99%", price: "€150" },
              { label: "Polish 1 pass (gloss)", note: "Light correction + gloss", price: "€400" },
              { label: "Polish 2-3 passes (correction)", note: "Advanced correction + mirror finish", price: "€800" },
            ],
          },
        ],
      },
      phase2: {
        label: "Phase 2 — Development",
        badge: "Coming",
        intro: "Once the permanent workshop is installed, Wrapp Man will open its second phase — services that require an even more rigorous environment: PPF Protection and Window Tinting.",
        groups: [
          {
            title: "PPF Protection (Paint Protection Film)",
            desc: "Invisible and durable protection against scratches, stone chips and UV.",
            items: [
              { label: "PPF Front end (front bumper block)", note: "Bumper, hood, fenders, mirrors, headlights", price: "€1,500" },
              { label: "PPF Specific zones", note: "Sills, handles, rockers, etc.", price: "€300" },
              { label: "PPF Full protection", note: "Entire vehicle", price: "€5,500" },
            ],
          },
          {
            title: "Window Tinting",
            desc: "Comfort, privacy and heat protection.",
            items: [
              { label: "Full window tint (car)", note: "All windows (except windshield)", price: "€400" },
              { label: "Headlight / lamp tint (pair)", note: "Protection and style", price: "€180" },
              { label: "Windshield tint", note: "According to regulations", price: "€250" },
            ],
          },
        ],
      },
      disclaimer: "All prices are indicative \"starting from\" and may vary based on vehicle condition, shape complexity, selected vinyl (Avery Dennison, 3M, HEXIS) and chosen options. A personalized quote is provided after inspection.",
    },
    payment: {
      tag: "/ Book & Pay",
      title1: "Book",
      title2: "online",
      subtitle: "Fixed-price packages payable by card: pay in full or a 50% deposit to lock your slot. Secure payment by Stripe.",
      full: "Full",
      deposit: "50% Deposit",
      pay: "Pay",
      securedBy: "100% secure payment — Visa · Mastercard",
      custom: {
        title: "Full wrap, semi-wrap or PPF?",
        desc: "These are bespoke projects (vehicle size, vinyl type). Request a quote: we then send you a payment link for the deposit (30–50%).",
        cta: "Request a custom quote",
      },
      packages: {
        reservation: { name: "Booking deposit", note: "Locks your slot — deducted from the final invoice." },
        lavage: { name: "Interior / Exterior Wash", note: "Full prep & cleaning." },
        toit: { name: "Roof Wrap", note: "Gloss or matte black roof." },
        feux: { name: "Light Tinting", desc: "", note: "Front / rear light tinting." },
        dechromage_citadine: { name: "Chrome Delete — City Car", note: "Complete chrome delete." },
        dechromage_berline: { name: "Chrome Delete — Sedan / SUV", note: "Complete chrome delete." },
      },
    },
    quote: {
      tag: "/ Free Quote",
      title1: "Let's talk",
      title2: "your project",
      subtitle: "Describe your vehicle and the desired service. We get back to you within 24h with a personalized estimate.",
      name: "Name *", namePh: "Your name",
      phone: "Phone *", phonePh: "+590 ...",
      email: "Email *", emailPh: "you@email.com",
      vehicle: "Vehicle brand / model *", vehiclePh: "e.g. Audi RS6, Porsche 911...",
      service: "Desired service *", servicePh: "Choose a service",
      message: "Message (optional)", messagePh: "Details, color, timeline...",
      submit: "Send my request", sending: "Sending...",
      successTitle: "Thank you!", successMsg: "Your request has been received. Our team will get back to you shortly.",
      newRequest: "New request",
      errRequired: "Please fill in all required fields.",
      errGeneric: "Something went wrong. Please try again.",
      okToast: "Request sent! We'll get back to you very soon.",
      serviceOptions: ["Partial Wrap", "Full Wrap", "Interior / Exterior Wash", "PPF Protection Film", "Other"],
    },
    footer: {
      blurb: "Car wrapping & paint protection studio. Precision, premium films and exceptional vehicles.",
      contact: "Contact", hours: "Opening hours",
      week: "Mon – Fri: 9am – 7pm", sat: "Saturday: 10am – 5pm", sun: "Sunday: Closed",
      rights: "All rights reserved.", tagline: "Wrapping · PPF · Chrome Delete",
    },
    pay: {
      checking: "Verifying payment...",
      successTitle: "Payment confirmed!",
      successMsg: "Thank you for your booking. A confirmation email will be sent. We'll contact you to finalize the appointment.",
      failTitle: "Payment not confirmed",
      failMsg: "The payment could not be verified. No amount was charged if the operation failed.",
      cancelTitle: "Payment cancelled",
      cancelMsg: "Your payment was cancelled. No amount was charged.",
      back: "Back to home",
    },
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("wm_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("wm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = TRANSLATIONS[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) return path;
      }
      return node;
    },
    [lang]
  );

  const toggle = useCallback(() => setLang((l) => (l === "fr" ? "en" : "fr")), []);

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
